module.exports = {["template-constructor-block-audio"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="player-wrapper"></div>\n	<div class="overlay"></div>\n';
}
return __p;
},}